import { inject, Injectable, signal } from '@angular/core';
import {
  AlertAdvisoriesItem,
  ContentAlertAdvisory
} from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  ApplicationAdvisoriesAem,
  ApplicationAdvisoriesListAem,
  ApplicationConfig,
  CommonService,
  CookieHelperService,
  CountryLanguageHelper,
  DarkSiteAem,
  FlyoutLangSelectorFacade,
  HeaderFooterMachCore,
  HeaderFooterMachCoreContentService,
  LoggingService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { ContentCountryLanguage } from '@com-delta-idp/mnx-sitewide-shared-utils';
import { AlertAdvisoriesAdaptersService } from '../../adapters/alert-advisories/alert-advisories-adapters.service';

@Injectable({
  providedIn: 'root'
})
export class AlertAdvisoriesExtendedFacade {
  alertAdvisoriesContent = signal<ContentAlertAdvisory>(
    {} as ContentAlertAdvisory
  );

  countryCode = '';
  languageCode = '';
  secondaryLanguageCode = '';
  countryLanguageContent: ContentCountryLanguage | null = null;

  advisories: AlertAdvisoriesItem | null = null;
  selectedAdvisory: ApplicationAdvisoriesListAem | null = null;
  contentAlertAdvisories: ApplicationAdvisoriesAem | null = null;
  darkSiteThemeContent: DarkSiteAem | null | undefined = null;
  flyoutLangSelectorLink = '';
  showAlertAdvisoriesHeader = signal<boolean>(false);
  isEnabled = 'true';

  adAlertCookie = '';
  adCookieArray: string[] = [];
  isAdvisoryMatch = false;
  isADNewCookierequired = false;
  isReady = signal<boolean>(false);

  contentService = inject(HeaderFooterMachCoreContentService);
  appConfig = inject(ApplicationConfig);
  commonService = inject(CommonService);
  cookieHelper = inject(CookieHelperService);
  loggingService = inject(LoggingService);
  selectorFacade = inject(FlyoutLangSelectorFacade);
  countryLanguageHelper = inject(CountryLanguageHelper);
  adapter = inject(AlertAdvisoriesAdaptersService);

  setContextPath(windowPath: string): string {
    if (!windowPath) {
      return 'home';
    }

    const contextPathArray = windowPath.split('/');
    const contextPath = contextPathArray[1] || 'home';

    return this.determineContextPath(contextPathArray, contextPath);
  }

  determineContextPath(
    contextPathArray: string[],
    contextPath: string
  ): string {
    if (contextPathArray.length !== 3) {
      return contextPath;
    }

    const prefLangVal = this.cookieHelper.getCookieValue('prefUI');
    return this.applyLanguagePreference(
      contextPathArray,
      contextPath,
      prefLangVal
    );
  }

  private applyLanguagePreference(
    contextPathArray: string[],
    contextPath: string,
    prefLangVal: string | null
  ): string {
    if (!prefLangVal) {
      return contextPath;
    }

    const prefLang = prefLangVal.split('-')[0].split('=')[1];
    const lang = contextPathArray[2];

    return lang && lang === prefLang ? 'home' : contextPath;
  }

  setAlertAdvisoriesContent(data: HeaderFooterMachCore): void {
    if (!this.selectedAdvisory) {
      return;
    }

    this.alertAdvisoriesContent.set(this.adapter.getContent(data));
    this.isReady.set(true);
  }
}
